import { createSlice } from '@reduxjs/toolkit';
import { fetchDeliveries, fetchDelivery, createDelivery, saveDelivery, uploadDeliveryAttachment } from './deliveryActions';
const storeDelivery = (state, data) => {
  state.byId[data.id] = { data, loading: false, saving: false, error: null, requestId: null };
  const list = state.byDate[data.deliveryDate];
  if (list && !list.ids.includes(data.id)) list.ids.push(data.id);
};
const slice = createSlice({
  name: 'deliveries',
  initialState: { byId: {}, byDate: {}, creating: false, createError: null },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchDeliveries.pending, (state, action) => {
      const date = action.meta.arg;
      state.byDate[date] = { ids: state.byDate[date]?.ids || [], loading: true, error: null, requestId: action.meta.requestId };
    }).addCase(fetchDeliveries.fulfilled, (state, action) => {
      const list = state.byDate[action.meta.arg];
      if (list?.requestId !== action.meta.requestId) return;
      list.loading = false;
      list.ids = action.payload.data.map(delivery => delivery.id);
      action.payload.data.forEach(delivery => {
        const record = state.byId[delivery.id];
        if (!record?.saving && (!record?.data || record.data.version <= delivery.version)) {
          state.byId[delivery.id] = { ...record, data: delivery, error: null };
        }
      });
    }).addCase(fetchDeliveries.rejected, (state, action) => {
      const list = state.byDate[action.meta.arg];
      if (list?.requestId !== action.meta.requestId) return;
      list.loading = false;
      list.error = action.meta.aborted ? null : action.payload;
    }).addCase(fetchDelivery.pending, (state, action) => {
      state.byId[action.meta.arg] = { ...state.byId[action.meta.arg], loading: true, error: null, requestId: action.meta.requestId };
    }).addCase(fetchDelivery.fulfilled, (state, action) => {
      const record = state.byId[action.meta.arg];
      if (record?.requestId !== action.meta.requestId) return;
      storeDelivery(state, action.payload.data);
    }).addCase(fetchDelivery.rejected, (state, action) => {
      const record = state.byId[action.meta.arg];
      if (record?.requestId !== action.meta.requestId) return;
      record.loading = false;
      record.error = action.meta.aborted ? null : action.payload;
    }).addCase(createDelivery.pending, state => { state.creating = true; state.createError = null; })
      .addCase(createDelivery.fulfilled, (state, action) => { state.creating = false; storeDelivery(state, action.payload.data); })
      .addCase(createDelivery.rejected, (state, action) => { state.creating = false; state.createError = action.payload; });
    [saveDelivery, uploadDeliveryAttachment].forEach(thunk => {
      builder.addCase(thunk.pending, (state, action) => {
        const record = state.byId[action.meta.arg.id];
        if (record) { record.saving = true; record.error = null; }
      }).addCase(thunk.fulfilled, (state, action) => storeDelivery(state, action.payload.data))
        .addCase(thunk.rejected, (state, action) => {
          const record = state.byId[action.meta.arg.id];
          if (record) { record.saving = false; record.error = action.payload; }
        });
    });
  },
});
export default slice.reducer;
